export const ContactStrategyName: Record<
  components['schemas']['ConversationStrategyEnum'],
  string
> = {
  email: 'Email',
  sms: 'SMS',
  whatsapp: 'WhatsApp',
}

export const EventStatusName: Record<
  components['schemas']['EventStatusEnum'],
  string
> = {
  draft: 'Borrador',
  closed: 'Cerrado',
  open: 'Abierto',
  cancelled: 'Cancelado',
}

export const EventStatusSeverity: Record<
  components['schemas']['EventStatusEnum'],
  string
> = {
  draft: 'secondary',
  closed: 'contrast',
  open: 'info',
  cancelled: 'warn',
}

export const OrderStatusName: Record<
  components['schemas']['OrderStatusEnum'],
  string
> = {
  complete: 'Completada',
  expired: 'Expirada',
  pending: 'Pendiente',
  refunded: 'Devuelta',
}

export const OrderStatusSeverity: Record<
  components['schemas']['OrderStatusEnum'],
  string
> = {
  complete: 'success',
  expired: 'contrast',
  pending: 'secondary',
  refunded: 'warn',
}
